import styles from './NotAnAdmin.module.css';

const NotAnAdmin = () => {
    return (
        <div className={styles.NotAnAdmin} data-testid="NotAnAdmin">
            <>
                <h1>
                    U hebt geen rechten om deze pagina te bezoeken.
                </h1>
            </>
        </div >
    )
};

export default NotAnAdmin;
